// User-facing Payroll date display: MM/DD/YY (ISO kept internally / in APIs).
export const fmtDate = (v) => {
  if (!v) return '—';
  const s = String(v).slice(0, 10);
  const parts = s.split('-');
  if (parts.length !== 3) return v;
  const [y, m, d] = parts;
  if (!y || !m || !d) return v;
  return `${m}/${d}/${y.slice(2)}`;
};

export const money = (v) => (v === null || v === undefined ? 'Not Available' : `$${Number(v).toFixed(2)}`);

// Reformat any ISO YYYY-MM-DD occurrences inside a preformatted string to MM/DD/YY.
export const fmtDateStr = (s) =>
  (s == null ? '—' : String(s).replace(/(\d{4})-(\d{2})-(\d{2})/g, (_, y, mo, d) => `${mo}/${d}/${y.slice(2)}`));

// Consistent Payroll visual priority: reminder (calm blue/navy) · action (amber) ·
// critical (red) · complete (green). Always pair color with an icon + plain text.
export const payrollTypeLabel = (g) => ({
  first_half: 'First-Half Payroll', second_half: 'Second-Half Payroll', monthly: 'Monthly Payroll',
}[g] || 'Payroll');

export const statusSeverity = (s) => ({
  period_open: 'reminder', closes_today: 'reminder', preparation_due: 'reminder', in_progress: 'reminder',
  due_today: 'action', deadline_may_be_missed: 'action', past_due: 'critical',
  rollout: 'reminder',
  submitted: 'complete', closed: 'complete',
}[s] || 'reminder');

export const SEVERITY = {
  reminder: { badge: 'bg-blue-100 text-blue-800', panel: 'border-blue-200 bg-blue-50 text-[#0E2A47]', accent: 'text-blue-600' },
  action: { badge: 'bg-amber-100 text-amber-800', panel: 'border-amber-200 bg-amber-50 text-amber-900', accent: 'text-amber-600' },
  critical: { badge: 'bg-red-100 text-red-700', panel: 'border-red-300 bg-red-50 text-red-800', accent: 'text-red-600' },
  complete: { badge: 'bg-emerald-100 text-emerald-700', panel: 'border-emerald-200 bg-emerald-50 text-emerald-800', accent: 'text-emerald-600' },
};
